import script from "./InvoiceChainMatrixCell.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceChainMatrixCell.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceChainMatrixCell.vue?vue&type=style&index=0&id=43e122fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e122fb"]])

export default __exports__